import { render, staticRenderFns } from "./AcctEditMain.vue?vue&type=template&id=641f6074&scoped=true&"
import script from "./AcctEditMain.vue?vue&type=script&lang=js&"
export * from "./AcctEditMain.vue?vue&type=script&lang=js&"
import style0 from "./AcctEditMain.vue?vue&type=style&index=0&id=641f6074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f6074",
  null
  
)

export default component.exports